import { getField, updateField } from 'vuex-map-fields';
import DeviceService from '../../services/DeviceService';
import Device from '../../models/Device';
import moment from 'moment';

export default {
  state: {
    clusterList: [],
  },

  actions: {
    showClusterList({ commit }, payload) {
      commit('setClusterList', payload);
    },
    unloadClusterList({ commit }) {
      commit('setClusterList', []);
    },
  },

  mutations: {
    setClusterList(state, payload) {
      state.clusterList = [...payload];
    },
  },
};
